<template>
  <div class="content">

    <OrderStage :id="194192" />

<!--    <TransactionHistory :id="192694" :autoload="true" />-->
<!--    <TransactionHistory :id="192461" :autoload="true" />-->
<!--    <TransactionHistory :id="192177" :autoload="true" />-->
<!--    <TransactionHistory :id="192204" :autoload="true" />-->
<!--    <TransactionHistory :id="192463" :autoload="true" />-->
<!--    <TransactionHistory :id="192470" :autoload="true" />-->
<!--    <QueuedTransaction :id="2002" />-->
  </div>
</template>

<script>
import Vue from 'vue'
import OrderDropdown from '@/components/OrderDropdown.vue'
import CustomerDropdown from '@/components/CustomerDropdown.vue'
import CustomerShippingEditor from '@/components/CustomerShippingEditor.vue'
import OrderPaymentEditor from '@/components/OrderPaymentEditor.vue'
import CustomerKlaviyo from '@/components/CustomerKlaviyo.vue'
import CreateOrder from '@/components/orders/CreateOrder.vue'
import UpForGrabs from '@/components/orders/UpForGrabs.vue'
import CancelOrder from '@/components/CancelOrder.vue'
import DebtCollection from '@/components/DebtCollection.vue'
import PickOrder from '@/components/PickOrder.vue'
import CustomerPaymentMethods from '@/components/CustomerPaymentMethods.vue'
import OrderShipment from '@/components/OrderShipment.vue'
import ExchangeRequestManager from '@/components/ExchangeRequestManager.vue'
import DiscountEditor from '@/components/DiscountEditor.vue'
import CustomerDiscountScheduler from '@/components/CustomerDiscountScheduler.vue'
import ProductTags from '@/components/ProductTags.vue'
import Cloning from '@/components/cloning/OrderCloning.vue'

export default {
  data: () => ({
    text: 'hey',
    number: 23,
    select: '',
    toggle: false,
    active_tab: 'one',
    tabs: {
      one: {
        name: 'One'
      },
      two: {
        name: 'Two'
      }
    }
  }),
  components: {
    Cloning,
    CustomerShippingEditor,
    OrderPaymentEditor,
    CustomerKlaviyo,
    CreateOrder,
    UpForGrabs,
    CancelOrder,
    CustomerPaymentMethods,
    DebtCollection,
    OrderShipment,
    ExchangeRequestManager,
    PickOrder,
    DiscountEditor,
    CustomerDiscountScheduler,
    ProductTags,
    OrderDropdown,
    CustomerDropdown
  },
  methods: {
    message () {
      this.$store.commit('addMessage', {
        message: 'Hello world'
      })
    },
    tabChange (id) {
      console.log(id, this.$refs)
    },
    clicked () {
      console.log('Cliked!')
    },
    product (p) {
      console.log(p)
    },
    variant (v) {
      console.log(v)
    }
  },
  created () {
    var date = Vue.$create.dateTime()

    console.log(date.addDays(1).format('Y-m-d H:i:s'))

    // Vue.$api.get('/order/95351/styling', {}, {
    // 	callback: data => console.log(data),
    // });

    // Vue.$api.get('/order/94755/letter', {}, {
    // 	callback: data => console.log(data),
    // });
  }
}
</script>
